import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Fairfax Convention</p>
        <h1>Experience Unforgettable Events.</h1>
        <p className="lede">
          At Fairfax Convention, we bring your vision to life with expertly curated events that leave a lasting impression. Discover how we can transform your ideas into reality.
        </p>
        <div className="cta-row">
          <a href="/services" target="_blank">
            Explore Our Services
          </a>
          <a href="/contact" target="_blank" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Seamless Planning</h2>
          <p>
            Our dedicated team handles every detail, ensuring a smooth planning process from start to finish.
          </p>
        </article>
        <article>
          <h2>Tailored Experiences</h2>
          <p>
            We customize each event to reflect your unique style and objectives, creating memorable experiences for all attendees.
          </p>
        </article>
        <article>
          <h2>Expert Support</h2>
          <p>
            With our extensive network and industry expertise, we provide the support you need to make your event a success.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;